import script from "./SearchBar.vue?vue&type=script&setup=true&lang=js"
export * from "./SearchBar.vue?vue&type=script&setup=true&lang=js"

import "./SearchBar.vue?vue&type=style&index=0&id=004071d8&scoped=true&lang=css"
import "./SearchBar.vue?vue&type=style&index=1&id=004071d8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-004071d8"]])

export default __exports__